import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from '@mui/icons-material';
import { SPACING } from '../../../../theme';
import PropTypes from 'prop-types';

/**
 * PromptPreview Component
 * Displays collapsible prompt preview with show more/less functionality
 */
const PromptPreview = ({ promptText }) => {
  const [promptExpanded, setPromptExpanded] = useState(false);

  if (!promptText) {
    return null;
  }

  const shouldTruncatePrompt = promptText.length > 200;
  const promptPreview = shouldTruncatePrompt
    ? promptText.substring(0, 200) + '...'
    : promptText;

  return (
    <Box sx={{ mb: SPACING.sm }}>
      <Box
        sx={{
          backgroundColor: 'grey.50',
          p: SPACING.sm,
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          position: 'relative',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontFamily: 'monospace',
            fontSize: '0.8125rem',
            lineHeight: 1.6,
            color: 'text.primary',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {promptExpanded ? promptText : promptPreview}
        </Typography>

        {shouldTruncatePrompt && (
          <Button
            size="small"
            onClick={() => setPromptExpanded(!promptExpanded)}
            endIcon={promptExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            sx={{
              mt: 1,
              textTransform: 'none',
              fontSize: '0.75rem',
              color: 'primary.main',
              minWidth: 'auto',
              px: 1,
            }}
          >
            {promptExpanded ? 'Show less' : 'Show more'}
          </Button>
        )}
      </Box>
    </Box>
  );
};

PromptPreview.propTypes = {
  promptText: PropTypes.string,
};

export default PromptPreview;
